import React, {useState, useEffect, useRef} from "react";
import { TextField, Checkbox, FormControlLabel, Typography, Box, Container, Button, MenuItem, Table, TableCell, TableRow, TableFooter, TableHead, TableBody, Grid, Radio, RadioGroup, FormLabel, FormControl, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Card, CardContent } from "@mui/material";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from "./api.js";
import PdfModalViewer from "./PdfModalViewer.js";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import { intValidator } from "./common/validators.js";
import HamburgerMenu from "./components/Hamburger.jsx";

const Comp9Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [showFormMenu, setShowFormMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [notApply, setNotApply] = useState(false);
  const [sameAsInvoice, setSameAsInvoice] = useState("different");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    user_9_name: "",
    user_9_department: "",
    user_9_phone: "",
    user_9_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    total_price: 0,
    carpet_color: "",
    sheet_color: "",
    other_items: "",
    alfa_text: "",
    details: [
        {
        item_id: null,
        number: 0,
      }
    ]
  });
  const [errors,setErrors] = useState({});
  const isMobile = useMediaQuery("(max-width:710px)");

  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

    const handleCorrection = async () => {
    try {
      const res = await api.patch('/api/forms/correction', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'correction');

      alert('再提出に更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('再提出処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };


    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'confirm');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);


  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");  

  const handleChange = (e) => {
    const { name, value, type, checked: isChecked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? isChecked : value,
    }));
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [invFieldsDisabled, setInvFieldsDisabled] = useState(false);

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_9_name: mypageData.user_name || "",
        user_9_department: mypageData.department || "",
        user_9_phone: mypageData.phone_number || "",
        user_9_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_9_name: "",
        user_9_department: "",
        user_9_phone: "",
        user_9_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  const handleSameAsInvoice = (value) => {
    setSameAsInvoice(value);

    if (value === "same") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: mypageData.company_name || "",
        invoice_user_name: mypageData.user_name || "",
        invoice_email: mypageData.email || "",
        invoice_address: mypageData.address || "",
        invoice_zip: mypageData.zip_code || "",
        invoice_tel: mypageData.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } else if (value === "different") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
      }));
      setInvFieldsDisabled(false);
    }
  };

  const handleParentInvoiceClick = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/parent-invoice/${mypageData.representative_id}`);
      const data = res.data;
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: data.company_name || "",
        invoice_user_name: data.user_name || "",
        invoice_email: data.email || "",
        invoice_address: data.address || "",
        invoice_zip: data.zip_code || "",
        invoice_tel: data.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } catch (error) {
      console.error("親出展者の請求情報取得に失敗しました:", error);
      alert("親出展者の情報を取得できませんでした。");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchO9InitialData = async () => {
        try {
        const user = JSON.parse(localStorage.getItem("user"));

        const [resStatus, resO9, resMypage] = await Promise.all([
            api.get(`/api/submission-status/${exhibitorId}`),
            api.get(`/api/o9submission/${exhibitorId}`),
            api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o9Status = resStatus.data?.o9_status || "";
        const o9Data = resO9.data || {};
        const mypage = resMypage.data || {};
        console.log(o9Data)

        if (o9Status === "申請しない") {
            setNotApply(true);
            setFormData({
            user_9_name: null,
            user_9_department: null,
            user_9_phone: null,
            user_9_tel: null,
            invoice_company_name: null,
            invoice_user_name: null,
            invoice_email: null,
            invoice_address: null,
            invoice_zip: null,
            invoice_tel: null,
            invoice_fax: null,
            total_price: null,
            carpet_color: null,
            sheet_color: null,
            other_items: null,
            alfa_text: null,
            details: []
            });
        } else {
            if (Object.values(o9Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
            })) {
            setFormData(prev => ({
                ...prev,
                ...o9Data,
                details: o9Data.details || []
            }));
            if (
              o9Data.user_9_name === mypage.user_name &&
              o9Data.user_9_department === mypage.department &&
              o9Data.user_9_phone === mypage.phone_number &&
              o9Data.user_9_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
            if (
                o9Data.invoice_company_name === mypage.company_name &&
                o9Data.invoice_user_name === mypage.user_name &&
                o9Data.invoice_email === mypage.email &&
                o9Data.invoice_address === mypage.address &&
                o9Data.invoice_tel === mypage.phone_number &&
                o9Data.invoice_zip === mypage.zip_code
            ) {
                setSameAsInvoice("same");
                setInvFieldsDisabled(true);
            } else {
                setInvFieldsDisabled(false);
            }
            }

            setNotApply(false);
        }

        } catch (err) {
        console.error("O9初期データ取得エラー:", err);
        }
    };

    fetchO9InitialData();
    }, []);


  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_9_name: "",
            user_9_department: "",
            user_9_phone: "",
            user_9_tel: "",
            invoice_company_name: "",
            invoice_user_name: "",
            invoice_email: "",
            invoice_address: "",
            invoice_zip: "",
            invoice_tel: "",
            invoice_fax: "",
            total_price: null,
            carpet_color: null,
            sheet_color: null,
            alfa_text: null,
            other_items: "",
            details: []
          });
      }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };  
  
    const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展概要(規定)', path: '/しんきんビジネスフェア2026出展概要_0709.pdf' },
      { label: '会場平面図', path: '/会場平面図.pdf' },
      { label: '荷物の発送について', path: '/荷物の発送について.pdf' },
      { label: 'お弁当について', path: '/お弁当について.pdf' },
      { label: '宿泊のご案内', path: '/宿泊のご案内.pdf' },
      { label: '来場者カード一覧', path: '/来場者カード一覧.pdf' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者申請システムログイン方法', path: '/出展社申請システムログイン方法.pdf' },
      // { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
      // { label: '出展者証について', path: '/出展者証について.pdf' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
      <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
          <div className="submenu">
              {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
              </a>
              ))}
          </div>
          )}
      </div>
    );

    const [items, setItems] = useState([]);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await api.get("/api/master/items-o9");
                setItems(res.data || []);
            } catch (err) {
                console.error("アイテム取得エラー:", err);
            }
        };
        fetchItems();
    }, []);

    const [noticeModalOpen, setNoticeModalOpen] = useState(false);
    const [ submitErrors, setSubmitErrors] = useState({});

    const handleSubmit = async () => {
      try {
        if (!exhibitorId || typeof exhibitorId !== "number") {
          alert("exhibitorId が不正です");
          return;
        }

        const submitErrors = {};

        if (!notApply) {
          if (!formData.user_9_name?.trim()) submitErrors.user_9_name = "入力してください";
          if (!formData.user_9_department?.trim()) submitErrors.user_9_department = "入力してください";
          if (!formData.user_9_phone?.trim()) submitErrors.user_9_phone = "入力してください";
          if (!formData.user_9_tel?.trim()) submitErrors.user_9_tel = "入力してください";
          if (!formData.invoice_company_name?.trim()) submitErrors.invoice_company_name = "入力してください";
          if (!formData.invoice_user_name?.trim()) submitErrors.invoice_user_name = "入力してください";
          if (!formData.invoice_email?.trim()) submitErrors.invoice_email = "入力してください";
          if (!formData.invoice_address?.trim()) submitErrors.invoice_address = "入力してください";
          if (!formData.invoice_zip?.trim()) submitErrors.invoice_zip = "入力してください";
          if (!formData.invoice_tel?.trim()) submitErrors.invoice_tel = "入力してください";
        }

        const fieldDisplayNames = {
          user_9_name: "担当者名",
          user_9_department: "担当部署",
          user_9_phone: "担当者携帯",
          user_9_tel: "担当者電話",
          invoice_company_name: "請求先会社名",
          invoice_user_name: "請求先担当者名",
          invoice_email: "請求先メールアドレス",
          invoice_address: "請求先住所",
          invoice_zip: "請求先郵便番号",
          invoice_tel: "請求先電話番号",
        };

        if (Object.keys(submitErrors).length > 0) {
          setSubmitErrors(submitErrors);
          window.scrollTo({ top: 0, behavior: "smooth" });

          const errorMessages = Object.entries(submitErrors)
            .map(([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`)
            .join("\n");

          alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
          return;
        }

        // details の型を成型（item_id → string, number → number）
        const cleanedDetails =
          formData.details
            ?.filter((item) => item.number !== 0 && item.item_id != null)
            .map((item) => ({
              item_id: String(item.item_id), // ここで文字列化
              number: item.number != null ? Number(item.number) : null,
            })) || [];

        const cleanedFormData = {
          ...formData,
          details: cleanedDetails,
        };

        const payload = {
          exhibitor_id: exhibitorId,
          formData: cleanedFormData,
          notApply: notApply,
        };

        const res = await api.post("/api/submit-o9", payload);

        if (res.status === 200) {
          setNoticeModalOpen(true);
          alert("保存成功");
        } else {
          alert("保存失敗");
        }
      } catch (err) {
        console.error(err);
        alert("エラー");
      }
    };

  const handleCloseNotice = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    setNoticeModalOpen(false);
    setTimeout(() => {
      if (isModal) {
        setFormModalOpen(false);
      } else {
        if (user?.user_id === 0) {
          navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
        } else {
          navigate(`/mypage/${user?.mypage_id}`);
        }
      }
    }, 1000);
  };

  useConfirmBackLogout(navigate);
  useNavigationHistory();
  const remarksRef = useRef(null);

  const user = JSON.parse(localStorage.getItem("user"));
  const [open , setOpen] = useState(false);
  const [openColor , setOpenColor] = useState(false);
  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="しんきんビジネスマッチング　ビジネスフェア2026 備品レンタル申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 768px) {
        .sp-column {flex-direction: column;}
        }
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
        <>
        <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0091BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#0091bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://shinkin-tokai.sakura.ne.jp/files/polisy.pdf', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Box sx={{ position: 'fixed', width: '14%' }}>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
        <Typography variant="h6">装飾備品レンタル申込</Typography>
        <Container sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <FormControlLabel
            control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
            label="申請しない"
            />

            {!notApply && (
            <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                担当者情報
                </Typography>
                <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                <Grid size={6}><TextField fullWidth label="氏名" name="user_9_name" value={formData.user_9_name} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_9_name} helperText={submitErrors.user_9_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="部署" name="user_9_department" value={formData.user_9_department} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_9_department} helperText={submitErrors.user_9_department} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
                <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_9_phone" value={formData.user_9_phone} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_9_phone} helperText={submitErrors.user_9_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
                <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_9_tel" value={formData.user_9_tel} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_9_tel} helperText={submitErrors.user_9_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                </Grid>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

                <Typography variant="h6" gutterBottom>
                請求先情報
                </Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsInvoice} onChange={(e) => handleSameAsInvoice(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                {user?.co_exhibit && sameAsInvoice === "different" && (
                  <Button
                    variant="outlined"
                    onClick={handleParentInvoiceClick}
                    disabled={loading}
                    style={{ marginBottom: "16px" }}
                  >
                    親出展者に請求する
                  </Button>
                )}
                </FormControl>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求先会社名" value={formData.invoice_company_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_company_name: e.target.value })} /></Grid>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求担当者名" value={formData.invoice_user_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_user_name: e.target.value })} /></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先メールアドレス" value={formData.invoice_email} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_email: e.target.value })} /></Grid>
                    <Grid size={6}><TextField fullWidth label="郵便番号" value={formData.invoice_zip} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_zip: e.target.value })} /></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先住所" value={formData.invoice_address} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_address: e.target.value })} /></Grid>
                    <Grid size={6}><TextField fullWidth label="電話番号" value={formData.invoice_tel} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_tel: e.target.value })} /></Grid>
                    <Grid size={6}><TextField fullWidth label="FAX番号" value={formData.invoice_fax} onChange={(e) => setFormData({ ...formData, invoice_fax: e.target.value })} /></Grid>
                </Grid>
            </Box>
            {/* <Box sx={{ display: 'flex', mt: 2 }} className="sp-column">
              <FormControl>
                <FormLabel>長机</FormLabel>
                <RadioGroup
                  row
                  name="basic_structure"
                  value={formData.basic_structure?.toString() ?? ""}
                  onChange={handleCatchRadio}
                >
                  <FormControlLabel value="true" control={<Radio />} label="使用する" />
                  <FormControlLabel value="false" control={<Radio />} label="使用しない" />
                </RadioGroup>
              </FormControl>

              <FormControl>
                <FormLabel>パイプ椅子</FormLabel>
                <RadioGroup
                  row
                  name="basic_chair"
                  value={formData.basic_chair?.toString() ?? ""}
                  onChange={handleCatchRadio}
                >
                  <FormControlLabel value="true" control={<Radio />} label="使用する" />
                  <FormControlLabel value="false" control={<Radio />} label="使用しない" />
                </RadioGroup>
              </FormControl>

             {!mypageData?.booth_corner && (
                <FormControl>
                  <FormLabel>側面パネル</FormLabel>
                  <RadioGroup
                    row
                    name="side_panel"
                    value={formData.side_panel?.toString() ?? ""}
                    onChange={handleCatchRadio}
                  >
                    <FormControlLabel value="true" control={<Radio />} label="使用する" />
                    <FormControlLabel value="false" control={<Radio />} label="使用しない" />
                  </RadioGroup>
                </FormControl>
              )}
            </Box> */}
            <Box sx={{mt: 2}}>
                <Box>
                    <Button variant="outlined" onClick={() => setOpen(true)}>各種装飾備品の画像を見る</Button>
                </Box>
                <PdfModalViewer
                    filePath="/しんきんビジネスフェア2026出展概要_0709.pdf"
                    isOpen={open}
                    onClose={() => setOpen(false)}
                    startPage={25}
                    endPage={26}
                />
                {isMobile ? (
                  <>
                  <Button
                    variant="contained"
                    onClick={() => {
                      remarksRef.current?.scrollIntoView({
                        behavior: "smooth",
                      });
                    }}
                    sx={{
                      position: "fixed",
                      bottom: 16,
                      right: 16,
                      zIndex: 1000,
                      borderRadius: "999px",
                    }}
                  >
                    備考へ
                  </Button>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {items.map((item, index) => {
                      const detail = formData.details.find(
                        (d) => d.item_id === item.item_id
                      );

                      const number = detail?.number || 0;
                      const unitTotal = item.unit_price * number;

                      const showNotice = [
                        "40-A",
                        "40-B",
                        "41-A",
                        "41-B",
                        "41-C",
                        "42",
                        "43",
                      ].includes(item.item_id);

                      const showColor = ["38", "39"].includes(item.item_id);

                      const colorValue =
                        item.item_id === "38"
                          ? formData.carpet_color
                          : item.item_id === "39"
                          ? formData.sheet_color
                          : "";

                      const handleValidatedNumberChange = (index) => (e) => {
                        const raw = e.target.value;

                        const { value, error } = intValidator({
                          label: "数量",
                        })(raw);

                        // エラー更新（行単位）
                        setErrors((prev) => ({
                          ...prev,
                          [`details_${index}_number`]: error,
                        }));

                        if (value === null) return;

                        const newDetails = [...formData.details];
                        const existingIndex = newDetails.findIndex(
                          (d) => d.item_id === items[index].item_id
                        );

                        if (existingIndex !== -1) {
                          newDetails[existingIndex].number = value === "" ? "" : Number(value);
                        } else {
                          newDetails.push({
                            item_id: items[index].item_id,
                            number: value === "" ? "" : Number(value),
                          });
                        }

                        // 合計再計算
                        const newTotal = items.reduce((acc, item) => {
                          const detail = newDetails.find((d) => d.item_id === item.item_id);
                          const number = detail?.number || 0;
                          return acc + item.unit_price * number;
                        }, 0);

                        setFormData({
                          ...formData,
                          details: newDetails,
                          total_price: newTotal,
                        });
                      };

                      const handleChangeColor = (e) => {
                          const val = e.target.value;
                          if (item.item_id === "38") {
                          setFormData({ ...formData, carpet_color: val });
                          } else if (item.item_id === "39") {
                          setFormData({ ...formData, sheet_color: val });
                          }
                      };

                      return (
                        <Card key={item.item_id}>
                          <CardContent>

                            <Typography variant="caption" color="text.secondary">
                              品番
                            </Typography>

                            <Typography
                              sx={{
                                fontFamily: "monospace",
                                mb: 1,
                              }}
                            >
                              {item.item_id}
                            </Typography>

                            <Typography variant="caption" color="text.secondary">
                              品名
                            </Typography>

                            <Typography sx={{ mb: 1 }}>
                              {item.item_name}
                            </Typography>

                            {showNotice && (
                              <Typography
                                color="error"
                                variant="body2"
                                sx={{ mb: 1 }}
                              >
                                ※電気使用及びコンセントの申込が必要です。
                              </Typography>
                            )}

                            {showColor && (
                              <>
                                <Box sx={{ mb: 2 }}>
                                  <Button
                                    variant="outlined"
                                    onClick={() => setOpenColor(true)}
                                  >
                                    色見本を表示する
                                  </Button>
                                </Box>

                                <PdfModalViewer
                                  filePath="/各種届出について.pdf"
                                  isOpen={openColor}
                                  onClose={() => setOpenColor(false)}
                                  startPage={3}
                                  endPage={3}
                                />
                              </>
                            )}

                            <Typography variant="caption" color="text.secondary">
                              単価(税込)
                            </Typography>

                            <Typography sx={{ mb: 2 }}>
                              ¥{item.unit_price.toLocaleString()}
                            </Typography>

                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              数量
                            </Typography>

                            <TextField
                              value={number}
                              onChange={handleValidatedNumberChange(index)}
                              size="small"
                              fullWidth
                              sx={{ mb: 2 }}
                              onWheel={(e) => e.target.blur()}
                              inputProps={{ min: 0 }}
                              error={!!errors[`details_${index}_number`]}
                              helperText={errors[`details_${index}_number`]}
                            />

                            <Typography variant="caption" color="text.secondary">
                              合計
                            </Typography>

                            <Typography
                              sx={{
                                fontWeight: "bold",
                                mb: number > 0 && showColor ? 2 : 0,
                              }}
                            >
                              ¥{unitTotal.toLocaleString()}
                            </Typography>

                            {number > 0 && showColor && (
                              <TextField
                                select
                                fullWidth
                                value={colorValue}
                                onChange={handleChangeColor}
                                label="色選択"
                                error={
                                  item.item_id === "38"
                                    ? !!submitErrors.carpet_color
                                    : !!submitErrors.sheet_color
                                }
                                helperText={
                                  item.item_id === "38"
                                    ? submitErrors.carpet_color
                                    : submitErrors.sheet_color
                                }
                              >
                                <MenuItem value="">
                                  色を選択してください
                                </MenuItem>

                                {(item.item_id === "38"
                                  ? [
                                      { value: "赤", label: "赤" },
                                      { value: "オレンジ", label: "オレンジ" },
                                      { value: "緑", label: "緑" },
                                      { value: "青", label: "青" },
                                      { value: "グレー", label: "グレー" },
                                    ]
                                  : [
                                      { value: "赤", label: "赤" },
                                      { value: "オレンジ", label: "オレンジ" },
                                      { value: "黄色", label: "黄" },
                                      { value: "緑", label: "緑" },
                                      { value: "青", label: "青" },
                                      { value: "みずいろ", label: "みずいろ" },
                                      { value: "グレー", label: "グレー" },
                                      { value: "黒", label: "黒" },
                                    ]).map((opt) => (
                                  <MenuItem
                                    key={opt.value}
                                    value={opt.value}
                                  >
                                    {opt.label}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          </CardContent>
                        </Card>
                      );
                    })}

                    <Card>
                      <CardContent>
                        <Typography variant="subtitle2">
                          総合計金額
                        </Typography>

                        <Typography variant="h6">
                          ¥{(formData.total_price ?? 0).toLocaleString()}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Box>
                  </>
                ) : (
                  <>
                  <Table size="small">
                    <TableHead>
                        <TableRow>
                        <TableCell sx={{width: '65px'}}>品番</TableCell>
                        <TableCell>品名</TableCell>
                        <TableCell sx={{width: '100px'}}>単価(税込)</TableCell>
                        <TableCell>数量</TableCell>
                        <TableCell>合計</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items.map((item, index) => {
                            const detail = formData.details.find(d => d.item_id === item.item_id);
                            const number = detail?.number || 0;
                            const unitTotal = item.unit_price * number;
                            const showNotice = ["40-A","40-B","41-A","41-B","41-C","42","43"].includes(item.item_id);
                            const showColor = ["38","39"].includes(item.item_id);

                            // 色選択のstate値を取得（formData内にある想定）
                            const colorValue = item.item_id === "38" ? formData.carpet_color : item.item_id === "39" ? formData.sheet_color : "";

                            const handleValidatedNumberChange = (index) => (e) => {
                              const raw = e.target.value;

                              const { value, error } = intValidator({
                                label: "数量",
                              })(raw);

                              // エラー更新（行単位）
                              setErrors((prev) => ({
                                ...prev,
                                [`details_${index}_number`]: error,
                              }));

                              if (value === null) return;

                              const newDetails = [...formData.details];
                              const existingIndex = newDetails.findIndex(
                                (d) => d.item_id === items[index].item_id
                              );

                              if (existingIndex !== -1) {
                                newDetails[existingIndex].number = value === "" ? "" : Number(value);
                              } else {
                                newDetails.push({
                                  item_id: items[index].item_id,
                                  number: value === "" ? "" : Number(value),
                                });
                              }

                              // 合計再計算
                              const newTotal = items.reduce((acc, item) => {
                                const detail = newDetails.find((d) => d.item_id === item.item_id);
                                const number = detail?.number || 0;
                                return acc + item.unit_price * number;
                              }, 0);

                              setFormData({
                                ...formData,
                                details: newDetails,
                                total_price: newTotal,
                              });
                            };

                            const handleChangeColor = (e) => {
                                const val = e.target.value;
                                if (item.item_id === "38") {
                                setFormData({ ...formData, carpet_color: val });
                                } else if (item.item_id === "39") {
                                setFormData({ ...formData, sheet_color: val });
                                }
                            };

                            return (
                                <React.Fragment key={item.item_id}>
                                <TableRow>
                                    <TableCell>
                                    <Typography sx={{ fontFamily: "monospace" }}>{item.item_id}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      {item.item_name}
                                      {showNotice && (
                                        <Typography color="error" variant="body2">
                                          ※電気使用及びコンセントの申込が必要です。
                                        </Typography>
                                      )}
                                      {showColor && (
                                        <>
                                        <Box>
                                            <Button variant="outlined" onClick={() => setOpenColor(true)}>色見本を表示する</Button>
                                        </Box>
                                        <PdfModalViewer
                                            filePath="/各種届出について.pdf"
                                            isOpen={openColor}
                                            onClose={() => setOpenColor(false)}
                                            startPage={3}
                                            endPage={3}
                                        />
                                        </>
                                      )}
                                    </TableCell>
                                    <TableCell>¥{item.unit_price.toLocaleString()}</TableCell>
                                    <TableCell>
                                    <TextField
                                      value={number}
                                      onChange={handleValidatedNumberChange(index)}
                                      size="small"
                                      fullWidth
                                      onWheel={(e) => e.target.blur()}
                                      inputProps={{ min: 0 }}
                                      error={!!errors[`details_${index}_number`]}
                                      helperText={errors[`details_${index}_number`]}
                                    />
                                    </TableCell>
                                    <TableCell>¥{unitTotal.toLocaleString()}</TableCell>
                                </TableRow>

                                {/* number > 0 かつ item_id が 38 or 39 のときだけ表示 */}
                                {number > 0 && (item.item_id === "38" || item.item_id === "39") && (
                                <TableRow>
                                    <TableCell colSpan={5}>
                                    <TextField
                                        select
                                        fullWidth
                                        value={colorValue}
                                        onChange={handleChangeColor}
                                        error={item.item_id === "38" ? !!submitErrors.carpet_color : !!submitErrors.sheet_color}
                                        helperText={item.item_id === "38" ? submitErrors.carpet_color : submitErrors.sheet_color}
                                    >
                                        <MenuItem value="">
                                        色を選択してください
                                        </MenuItem>
                                        {(item.item_id === "38" ? [
                                        { value: "赤", label: "赤" },
                                        { value: "オレンジ", label: "オレンジ" },
                                        { value: "緑", label: "緑" },
                                        { value: "青", label: "青" },
                                        { value: "グレー", label: "グレー" },
                                        ] : [
                                        { value: "赤", label: "赤" },
                                        { value: "オレンジ", label: "オレンジ" },
                                        { value: "黄色", label: "黄" },
                                        { value: "緑", label: "緑" },
                                        { value: "青", label: "青" },
                                        { value: "みずいろ", label: "みずいろ" },
                                        { value: "グレー", label: "グレー" },
                                        { value: "黒", label: "黒" },
                                        ]).map(opt => (
                                        <MenuItem key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </MenuItem>
                                        ))}
                                    </TextField>
                                    </TableCell>
                                </TableRow>
                                )}
                                </React.Fragment>
                            );
                            })}
                    </TableBody>
                    <TableFooter>
                    <TableRow>
                        <TableCell colSpan={4} align="right">
                        <Typography variant="subtitle1">総合計金額:</Typography>
                        </TableCell>
                        <TableCell>
                        <Typography variant="subtitle1">
                            ¥{(formData.total_price ?? 0).toLocaleString()}
                        </Typography>
                        </TableCell>
                    </TableRow>
                    </TableFooter>
                    </Table>
                    </>
                )}
                <Typography variant="h7" ref={remarksRef}>その他備品</Typography>
                <Typography color="error">※上記以外の備品レンタルを行う場合はコチラにご入力ください。</Typography>
                <TextField fullWidth label="その他備品" value={formData.other_items} onChange={(e) => setFormData({ ...formData, other_items: e.target.value })} placeholder="○○　5個 など" />
                <Typography variant="h6">備考欄</Typography>
                <Typography color="error">※装飾備品レンタル申込について補足事項等がある場合はコチラにご入力ください。</Typography>
                <TextField fullWidth multiline rows={8} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
            </Box>
            </>
            )}
        </Container>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography>
            【上記入力内容についてのお問い合わせ先】<br />
            ビジネスフェア2026企画運営室（中部経済新聞社 事業部内）<br />
            担当：中島、佐野<br />
            TEL:052-561-5675<br />
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
            ※お急ぎの場合はお電話にてお問い合わせください。
          </Typography>
        </Box>
        </Container>
      </Container>
      {!isCorpModal &&(
        <>
        <Container sx={{textAlign: 'center'}}>
            <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                提出する
            </Button>
        </Container>
        <Dialog open={noticeModalOpen} onClose={handleCloseNotice}>
          <DialogTitle>注意事項</DialogTitle>
          <DialogContent>
            <p>
              各種レンタル備品の設置位置を「ブース平面図」よりご提出ください。
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNotice} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
       </>
      )}
      {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button
          variant="contained"
          onClick={handleCorrection}
          sx={{
            backgroundColor: "red",
            color: "white",
            "&:hover": {
              backgroundColor: "darkred",
            },
          }}
        >
          再提出
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          完了
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
  );
};

export default Comp9Sub;